export default "__VITE_ASSET__CRzlQaYl__"